<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>积分多倍促销</span>
				<el-button class="button" @click='edit("")' type="success">新增</el-button>
			</div>
		</template>
		<el-table :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据"
		 v-loading="loading" :data="list" style="width: 100%;" border highlight-current-row>
			<el-table-column prop="id" label="编号" width="180"></el-table-column>
			<el-table-column prop="return_point_muti" label="返还积分倍数"></el-table-column>
			<el-table-column label="开始时间">
				<template #default="scope">
					{{timestampToTime(scope.row.start_time)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间">
				<template #default="scope">
					{{timestampToTime(scope.row.end_time)}}
				</template>
			</el-table-column>
			<el-table-column align="right">
					<template #header>
						<span>操作</span>
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
						<el-button type="danger" size="medium" @click="destroy(scope.row)">删除</el-button>
					</template>
				</el-table-column>
		</el-table>
	</el-card>
	<el-dialog :title='title' v-model="dialogFormVisible">
		<el-form label-position='left' :model="item" ref="form" :rules="rules" label-width="170px">
			<el-form-item label="下单返还积分倍数" prop="return_point_muti">
				<el-input-number controls-position="right" :min="1" clearable size="medium" v-model="item.return_point_muti"
				 placeholder="积分倍数" autocomplete="off"></el-input-number>
			</el-form-item>
			<el-form-item label="积分时间">
				<el-row :gutter="20">
					<el-col :span="10">
						<el-form-item prop="start_time">
							<el-input v-model="item.start_time" type="date" placeholder="开始时间"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item prop="end_time">
							<el-input v-model="item.end_time" type="date" placeholder="结束时间"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'PointMutiPromotion',
		data() {
			return {
				dialogFormVisible: false,
				title: '新增',
				loading: true,
				list: [],
				item: {
					return_point_muti: 1,
					start_time: '',
					end_time: '',
				},
				rules: {
					return_point_muti: [{
						required: true,
						message: '请填写积分倍数',
						trigger: 'blur'
					}],
					start_time: [{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time: [{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			edit(row) {
				console.log(row)
				let temp = this.cloneObj(row);
				if (row) {
					this.title = '编辑';
					this.item.return_point_muti=temp.return_point_muti;
					this.item.start_time=this.timestampToTime(temp.start_time);
					this.item.end_time=this.timestampToTime(temp.end_time);
					this.item.id = temp.id;
				} else {
					this.resetObj(this.item)
				}
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			destroy(row) {
				console.log(row.id)
				let id = row.id
				// return false;
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/promotion/pointMutiPromotionDel', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getPointMutiPromotion();
				})
			},
			submit() {
				console.log(this.item);
				// return false;
				this.$refs['form'].validate((valid) => {
					if (valid) {
						// console.log(this.item)
						// return false;
						this.httpPost({
							url: '/admin/promotion/pointMutiPromotionUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getPointMutiPromotion();
						})

					} else {
						console.log('error submit!!');
						return false;
					}
				})

			},
			getPointMutiPromotion(){
				this.httpPost({
					url: '/admin/promotion/pointMutiPromotionList',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.list = temp;
					this.loading = false;
							
				}).catch((err) => {})
			}
		},
		created() {
			this.getPointMutiPromotion();
		}
	}
</script>

<style>
</style>
